import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Title = styled.h1`
  margin: 32px 0 36px 0;

@media (max-width: ${defaultBreakpoints.medium}) {
  margin: 24px 0px;
}
`;

export const EventsPaginationWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: center;
`;

export const Info = styled.p`
  font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-top: 36px;

  @media (max-width: ${defaultBreakpoints.medium}) {
    font-size: 20px;
    margin-top: 24px;
  }
`;
